import { Box } from "@mui/material";
import { useMemo } from "react";

import AcquisitionBreakdownSection from "../AcquisitionBreakdownSection";
import CityDrillDownPanel from "../components/CityDrillDownPanel";
import IranDistributionMapSection from "../components/IranDistributionMapSection";
import ProvincePerformanceRanking from "../components/ProvincePerformanceRanking";
import { pick } from "../managementDashboardUtils";

const GeographyIntelligenceTab = ({
  acquisitionLoading,
  acquisitionError,
  acquisitionData,
  bottlenecksLoading,
  bottlenecksError,
  bottlenecksData,
  dashboardFilters,
  loadAcquisitionBreakdown,
  loadOperationalBottlenecks,
}) => {
  const selectedProvinceId = dashboardFilters?.provinceId ?? null;
  const provinceRows = bottlenecksData?.provinceRanking || bottlenecksData?.ProvinceRanking || [];
  const selectedProvinceTitle = useMemo(() => {
    if (!selectedProvinceId) return null;
    const match = provinceRows.find(
      (row) => pick(row, "provinceId", "ProvinceId") === Number(selectedProvinceId)
    );
    return match ? pick(match, "provinceTitle", "ProvinceTitle") : null;
  }, [provinceRows, selectedProvinceId]);

  return (
    <Box>
      <IranDistributionMapSection />

      <AcquisitionBreakdownSection
        loading={acquisitionLoading}
        error={acquisitionError}
        data={acquisitionData}
        onRetry={() => loadAcquisitionBreakdown(dashboardFilters)}
      />

      <ProvincePerformanceRanking
        loading={bottlenecksLoading}
        error={bottlenecksError}
        data={bottlenecksData}
        onRetry={() => loadOperationalBottlenecks(dashboardFilters)}
      />

      <CityDrillDownPanel
        provinceId={selectedProvinceId}
        provinceTitle={selectedProvinceTitle}
      />
    </Box>
  );
};

export default GeographyIntelligenceTab;
